import { useCallback, useEffect, useState } from 'react'
import { fetchWithAuth } from '@/lib/api'

type Counts = { reviewRequested: number; needsReview: number }

/** Fetch review-requested and needs-review counts for a workspace Browse nav badge. */
export function useKnowledgeHubQueueCounts(workspaceId: string | null | undefined, enabled: boolean) {
  const [counts, setCounts] = useState<Counts>({ reviewRequested: 0, needsReview: 0 })
  const [loading, setLoading] = useState(false)

  const refresh = useCallback(async () => {
    if (!workspaceId || !enabled) {
      setCounts({ reviewRequested: 0, needsReview: 0 })
      return
    }
    setLoading(true)
    try {
      const [rqRes, nrRes] = await Promise.all([
        fetchWithAuth(`/api/knowledge-hub/queue?workspace_id=${workspaceId}&status=review-requested`),
        fetchWithAuth(`/api/knowledge-hub/queue?workspace_id=${workspaceId}&status=needs-review`),
      ])
      const rq = rqRes.ok ? await rqRes.json() : { count: 0 }
      const nr = nrRes.ok ? await nrRes.json() : { count: 0 }
      setCounts({
        reviewRequested: rq.count ?? 0,
        needsReview: nr.count ?? 0,
      })
    } catch {
      setCounts({ reviewRequested: 0, needsReview: 0 })
    } finally {
      setLoading(false)
    }
  }, [workspaceId, enabled])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return { counts, loading, refresh }
}
